// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Modal, Button, Segment } from 'semantic-ui-react';
import _ from 'lodash';
// local
// libs
import { _val } from 'app/lib/helper';
import { isFormValid } from 'app/lib/formHelper';
// views
import Notification from 'app/ui/commons/notification/Notification';
import DropdownDevices from 'app/ui/commons/DropdownDevices';
import CustomDropdown from 'app/ui/commons/CustomDropdown';
import ErrorLabel from 'app/ui/commons/ErrorLabel';
// actions
import { init, closeModal } from 'app/redux/actions/patient/enableModal';
// consts
import { STATUS } from 'salvus-shared/consts/patient';

class EnablePatientModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patient: null,
            errors: {},
            form: this.initForm(),
            cylinders: this.initCylinderQuantity(),
        };
    }

    componentWillUnmount = () => this.onClose();

    componentWillReceiveProps(nextProps) {
        const { data } = nextProps.enablePatientModal;
        if (data) {
            this.setState({
                patient: data,
                form: this.initForm(data),
                errors: {},
                cylinders: this.initCylinderQuantity(data.cylinders),
            });
        }
    }

    initForm(data = {}) {
        return {
            deviceId: _val(data.deviceId, null),
            oldStatus: data.status,
            fullCylinders: null,
            emptyCylinders: null,
        };
    }

    validateForm(form, field) {
        const errors = {};
        const fullCylinders = form.fullCylinders;
        if (!field || field === 'fullCylinders') {
            if (fullCylinders === null) {
                errors['fullCylinders'] = 'O campo cilindros cheios é obrigatório.';
            } else {
                errors['fullCylinders'] = undefined;
            }
        }

        const emptyCylinders = form.emptyCylinders;
        if (!field || field === 'emptyCylinders') {
            if (_.isEmpty(emptyCylinders)) {
                errors['emptyCylinders'] = 'O campo cilindros vazios é obrigatório.';
            } else {
                errors['emptyCylinders'] = undefined;
            }
        }

        if ((!field || field === 'fullCylinders' || field === 'emptyCylinders') && (!_.isNil(fullCylinders) && !_.isNil(emptyCylinders))) {
            if (fullCylinders === 0 && emptyCylinders === 0) {
                errors['fullCylinders'] = 'Os campos cilindro cheio e vazio não podem ser 0 ao mesmo tempo.';
                errors['emptyCylinders'] = 'Os campos cilindro cheio e vazio não podem ser 0 ao mesmo tempo.';
            } else {
                errors['fullCylinders'] = undefined;
                errors['emptyCylinders'] = undefined;
            }
        }

        const deviceId = form.deviceId;
        if (!field || field === 'deviceId') {
            if (deviceId === null) {
                errors['deviceId'] = 'O campo dispositivo é obrigatorio.';
            } else {
                errors['deviceId'] = undefined;
            }
        }

        return errors;
    }

    initCylinderQuantity(maxValue = 15) {
        const options = [];
        for (let i = 0; i <= maxValue; i++) {
            options.push({ key: i, text: i, value: i });
        }
        return options;
    }

    hasError = field => !_.isEmpty(this.state.errors[field]);

    onChange = field => (e, target) => {
        const { value } = target || e.target;
        let { form, errors } = this.state;
        _.set(form, field, value);
        if (field === 'fullCylinders') {
            _.set(form, 'emptyCylinders', this.state.patient.cylinders - value);
        } else if (field === 'emptyCylinders') {
            _.set(form, 'fullCylinders', this.state.patient.cylinders - value);
        }
        const validation = this.validateForm(form, field);
        _.forIn(validation, function(value, key) {
            errors[key] = value;
        });
        this.setState({ form, errors });
    };

    onClose = () => this.props.dispatch(closeModal());

    onSubmit = () => {
        const { patient, form } = this.state;
        const errors = this.validateForm(form);
        if (!isFormValid(errors)) {
            this.setState({ errors });
            // return false to not close the popup
            return false;
        }

        this.props.dispatch(init(patient.id, form, this.props.enablePatientModal.onSuccessCallback));
    };

    render() {
        // state
        const { form, cylinders, patient, errors } = this.state;
        // props
        const { isOpened, loading, error } = this.props.enablePatientModal;
        return (
            <Modal size="small" open={isOpened} onClose={this.onClose}>
                <Modal.Header>{patient && patient.status === STATUS.NEW ? 'Inicializar' : 'Reativar'} - Paciente</Modal.Header>
                <Segment vertical loading={loading}>
                    {error ? <Notification message={error.errors} isError /> : null}
                    <Modal.Content>
                        <Form>
                            <Form.Group>
                                <DropdownDevices
                                    width={16}
                                    patient={patient}
                                    value={form.deviceId}
                                    label={<ErrorLabel label="DISPOSITIVO" error={errors['deviceId']} />}
                                    Dispositivos={'DISPOSITIVO'}
                                    onChange={this.onChange('deviceId')}
                                    error={errors['deviceId']}
                                />
                            </Form.Group>
                            Número de cilindros:
                            <br /> <br />
                            <Form.Group>
                                <CustomDropdown
                                    placeholder="CHEIOS"
                                    label={<ErrorLabel label="CHEIOS" error={errors['fullCylinders']} />}
                                    selection
                                    width={8}
                                    options={cylinders}
                                    value={form.fullCylinders}
                                    onChange={this.onChange('fullCylinders')}
                                    error={this.hasError('fullCylinders')}
                                />
                                <CustomDropdown
                                    placeholder="VAZIOS"
                                    label={<ErrorLabel label="VAZIOS" error={errors['emptyCylinders']} />}
                                    selection
                                    width={8}
                                    options={cylinders}
                                    value={form.emptyCylinders}
                                    onChange={this.onChange('emptyCylinders')}
                                    error={this.hasError('emptyCylinders')}
                                />
                            </Form.Group>
                            * Cilindros em uso devem ser considerados CHEIOS.
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button content="Cancelar" onClick={this.onClose} />
                        <Button className="highlight" content="Salvar" onClick={this.onSubmit} />
                    </Modal.Actions>
                </Segment>
            </Modal>
        );
    }
}

EnablePatientModal.propTypes = {
    enablePatientModal: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    enablePatientModal: state.enablePatientModal,
});
export default connect(mapStateToProps)(EnablePatientModal);
